import React from "react";

// Import images
import chatAnnounce from "../assets/img/Products/chat-announce.svg";
import landingPageSolutions from "../assets/img/Products/Landing-page-solutions-2-new.svg";
import chatRespond from "../assets/img/Products/chat-respond.svg";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const ChatProduct = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Products
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item">
              <a href="#">Products</a>
            </li>
            <li className="breadcrumb-item active text-primary">
              Chat Shopify
            </li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <div className="container">
        <div className="row g-5">
          <div className="col-md-6 col-lg-6">
            <div className="user-selection">
              <div className="rounded">
                <img
                  src={chatAnnounce}
                  className="img-fluid rounded"
                  alt="Mobile-app-development"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 p-5">
            <h1>Transform Your Shopify Store with Epic-X Chat Integration</h1>
           <p className="font-size-p">
              Boost customer engagement and conversions with Epic-X
              Chat-Shopify, a seamless chat integration designed for Shopify
              stores. Provide real-time assistance, automate responses, and
              enhance user experience with AI-powered chat support.
            </p>
            <div className="features-container">
              <h2>Key Features</h2>
              <div className="epic-pro-feature-item">
                <span>&#9989;</span> Instant Customer Support
              </div>
              <div className="epic-pro-feature-item">
                <span>&#9989;</span> AI-Driven Chatbots
              </div>
              <div className="epic-pro-feature-item">
                <span>&#9989;</span> Multi-Channel Messaging
              </div>
              <div className="epic-pro-feature-item">
                <span>&#9989;</span> Order Tracking & Assistance
              </div>
              <div className="epic-pro-feature-item">
                <span>&#9989;</span> Personalized Shopping Experience
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5 mt-12">
              <h1>Flexible Pricing Plans for Every Business</h1>
             <p className="font-size-p">
                We offer scalable pricing plans to fit every Shopify store’s
                needs. Choose the best option for your business and start
                engaging with your customers today!
              </p>
              <h2>Pricing Plans</h2>
              <div className="pricing">
                <div>
                  <span>&#128161;</span>
                  <strong>Basic Plan:</strong> Free – Live chat integration with
                  limited AI features.
                </div>
                <div>
                  <span>&#128640;</span>
                  <strong>Pro Plan:</strong> $XX/month – Advanced chatbot
                  automation & order tracking.
                </div>
                <div>
                  <span>&#128293;</span>
                  <strong>Enterprise:</strong> Custom – Tailored solutions for
                  high-volume stores.
                </div>
                <a
                  href="#"
                  className="btn-epic-x btn-primary rounded-pill py-2 px-4 ms-3 mt-2"
                >
                  Start Free Trial
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={landingPageSolutions}
                    className="img-fluid rounded w-70"
                    alt="About-epic-X Process"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <div className="container">
        <div className="row g-5">
          <div className="col-md-6 col-lg-6">
            <div className="user-selection">
              <div className="rounded">
                <img
                  src={chatRespond}
                  className="img-fluid rounded"
                  alt="Mobile-app-development"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 p-5">
            <h1>Why Choose Epic-X Chat for Your Shopify Store?</h1>
           <p className="font-size-p">
              Epic-X Chat empowers your Shopify store with cutting-edge
              communication tools to improve customer satisfaction and drive
              sales.
            </p>
            <div className="features-container">
              <h2>Key Benefits</h2>
              <div className="epic-item">
                <span>&#128722;</span> Boost Sales – Engage visitors, recommend
                products, and recover abandoned carts.
              </div>
              <div className="epic-item">
                <span>&#128172;</span> 24/7 Support – AI-powered chatbots handle
                customer queries anytime.
              </div>
              <div className="epic-item">
                <span>&#128230;</span> Order Assistance – Customers can track
                orders directly via chat.
              </div>
              <div className="epic-item">
                <span>&#128202;</span> Insights & Analytics – Get real-time
                customer insights to improve interactions.
              </div>
              <div className="epic-item">
                <span>&#128279;</span> Seamless Integration – Easy setup with
                Shopify and other third-party apps.
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* B2B Feature End */}
      <Footer />
    </div>
  );
};

export default ChatProduct;
